import { render, staticRenderFns } from "./BackstageSetting.vue?vue&type=template&id=f67c7c9a&scoped=true&"
import script from "./BackstageSetting.vue?vue&type=script&lang=js&"
export * from "./BackstageSetting.vue?vue&type=script&lang=js&"
import style0 from "./BackstageSetting.vue?vue&type=style&index=0&id=f67c7c9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67c7c9a",
  null
  
)

export default component.exports